<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fy6HkK/tc-custom/9781523094370.jpg?1737919186712" alt="This image is the cover for the book Leadership from the Inside Out"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Leadership from the Inside Out
      </h1>
      <p class="bookDescription body article font2">
        <b>“Cashman’s book on why personal development is essential to exemplary leadership is a classic” (<i>The Washington Post</i>).</b><br/><br/> In the revised third edition of this seminal work, author Kevin Cashman offers stories, exercises, and practices to help readers develop heightened awareness, courage, character, authenticity, purpose, agility, service, and contribution. These so-called soft skills no longer can be dismissed as “nice-to-haves.” Research shows they are foundational for high performance and enduring value creation.<br/><br/> Balancing timeless principles with emerging research, this new edition offers:<br/><br/> • Updated content throughout and two new chapters: “Story Mastery” and “Coaching Mastery”<br/> • New case studies, stories, and exercises in every chapter<br/> • New validating research from the frontiers of leadership, neuroscience, psychology, and human potential<br/> • An even more powerful and transformative development experience<br/><br/> Framed in eight profound and pragmatic “mastery areas,” this book serves as an integrated growth experience that helps leaders understand how to harness their authentic, value-creating influence and elevate their impact. Cashman demonstrates that his trademark “grow the whole person to grow the whole leader” approach, focusing on purpose-driven leadership, is even more relevant in today’s hypercomplex world. For everyone from CEOs to emerging leaders, this new edition of a proven classic advances the art and science of leadership.<br/><br/><b>“<i>Leadership from the Inside Out</i> is a major paradigm shift in leadership development. It gives you the tools to go directly to the heart of all significant leadership transformation: growing as a person to grow as a leader.” —Paul Walsh, former chairman and CEO, Diageo</b><br/><br/><b>“Kevin Cashman demonstrates convincingly why authenticity in leadership is essential for effectiveness. His process of developing the leader from within provides readers the road map to transform themselves and their organizations.” —Bill George, author of <i>True North</i>; Senior Fellow, Harvard Business School; and former Chairman and CEO, Medtronic</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin Cashman
      </h2>
      
      <p class="authorDescription body article">Kevin Cashman is senior partner, CEO and executive development, at Korn Ferry, a global keynote speaker, and the bestselling author of six books, including The Pause Principle.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publishers, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3e29ca14